import { Routes, UrlSegment } from "@angular/router";
import { OktaAuthGuard, OktaCallbackComponent } from "@okta/okta-angular";
import { ApplicationListComponent } from "./domains/applications/feature/application-list/application-list";
import { ContentPageComponent } from "./domains/coremedia/content/feature/coremedia-content-renderer/content-page";
import { LegalPageComponent } from "./domains/coremedia/content/feature/legal-page/legal-page";
import { NotFoundPageComponent } from "./domains/coremedia/content/feature/not-found/not-found-page";
import { DashboardComponent } from "./domains/dashboard/feature/dashboard/dashboard";
import { piaRoutes } from "./domains/pia/pia.routes";
import { previewModeGuard } from "./shared/preview-mode.guard";

const prefixMatcher = (prefix: string) => (segments: UrlSegment[]) => {
  if (segments.length === 0 || segments[0]?.path !== prefix) {
    return null;
  }
  return { consumed: segments };
};

const fullPathMatcher = prefixMatcher("cms");

/**
 * Matches the footer legal-links pages, which must always carry the `legal` prefix segment.
 * Kept separate from `fullPathMatcher` since legal content lives in its own CoreMedia site
 * (see `environment.footerLegalLinks`) and is resolved/rendered differently (localized).
 */
const legalPathMatcher = prefixMatcher("legal");

const internationalPathMatcher = prefixMatcher("int");

export const routes: Routes = [
  {
    path: "security/okta/login",
    component: OktaCallbackComponent,
  },
  {
    component: ApplicationListComponent,
    path: "applications",
    canActivate: [OktaAuthGuard],
  },
  {
    component: DashboardComponent,
    path: "",
    pathMatch: "full",
    canActivate: [OktaAuthGuard],
  },
  {
    path: "dashboard",
    redirectTo: "/",
    pathMatch: "full",
  },
  {
    component: ContentPageComponent,
    path: "cms-id/:id",
    canActivate: [OktaAuthGuard],
    canMatch: [previewModeGuard],
  },
  {
    component: ContentPageComponent,
    matcher: fullPathMatcher,
    canActivate: [OktaAuthGuard],
  },
  {
    component: LegalPageComponent,
    matcher: legalPathMatcher,
    canActivate: [OktaAuthGuard],
  },
  {
    component: ContentPageComponent,
    matcher: internationalPathMatcher,
    canActivate: [OktaAuthGuard],
    data: { routePrefix: "int" },
  },
  {
    component: NotFoundPageComponent,
    path: "not-found",
    canActivate: [OktaAuthGuard],
  },
  ...piaRoutes,
  {
    component: NotFoundPageComponent,
    path: "**",
  },
];
